import { accessCardConstants } from "@constants";

const initalState = {
  query: {
    loading: false,
    constructionUuid: null,
    condition: {},
    total: 0,
    items: [],
    fail: null
  }
};

export const accessCards = (state = initalState, action) => {
  switch (action.type) {
    case accessCardConstants.GET_ALL_REQUEST:
      return {
        ...state,
        query: {
          ...initalState.query,
          loading: true
        }
      };
    case accessCardConstants.GET_ALL_SUCCESS:
      const { total, items, condition, constructionUuid } = action;
      return {
        ...state,
        query: {
          ...initalState.query,
          loading: false,
          constructionUuid,
          condition,
          total,
          items
        }
      };
    case accessCardConstants.GET_ALL_FAILURE:
      const { error } = action;
      return {
        ...state,
        query: {
          ...initalState.query,
          loading: false,
          fail: error
        }
      };
    case accessCardConstants.RESET_ALL_SUCCESS:
      return initalState;
    default:
      return state;
  }
};
